const pageData = [
  {
    order: 1,
    title: "Ninja",
    heading: "Ninja",
    subheading:
      "Att söka efter en ninja har varit populärt inom IT-branschen. Men vad betyder det egentligen?",
    dl1:
      "Det är lätt att missa bra kandidater med andra erfarenheter om man använder för snäva och kreativa uttryck.",
    link: "/ninja/"
  },
  {
    order: 2,
    title: "Quiz",
    heading: "Ninja",
    subheading:
      'Ordet ninja är japanska och betyder "dold person". Inom populärkulturen är ninjor är ofta någon typ av krigare.',
    link: "/ninja/02/",
    quizHeading: "Vad gör en ninja på jobbet enligt dig?",
    quizAnswer1: {
      content: "Väljer vägen som leder till bäst resultat",
      note: "Prioriteringskompetens"
    },
    quizAnswer2: {
      content: "Förnyar eller förbättrar kontinuerligt sitt sätt att arbeta",
      note: "Utvecklingskompetens"
    },
    quizAnswer3: {
      content: "Kommer till självständiga beslut när det krävs",
      note: "Prioriteringskompetens"
    },
    quizAnswer4: {
      content: "Växlar sitt arbetstempo när det krävs",
      note: "Anpassningskompetens"
    },
    quizAnswer5: {
      content: "Ingen aning"
    },
    modal: {
      heading: "Ninja",
      subheading: "Grattis!",
      body:
        "Din färdighet att undvika branschklyschor har skärpts. Slutför jakten på den oslipade diamanten.",
      buttonText: "Slutför jakten!"
    }
  }
];

export default pageData;



// WEBPACK FOOTER //
// ./src/data/ninja.js